import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, Orbit } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'משימות',
    href: '#missions'
  }, {
    name: 'טכנולוגיה',
    href: '#technology'
  }, {
    name: 'צי',
    href: '#fleet'
  }, {
    name: 'צוות',
    href: '#team'
  }, {
    name: 'צור קשר',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#03040a]/80 backdrop-blur-md border-b border-white/10 py-3' : 'bg-transparent py-5'}`} data-id="element-140">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-141">
        <div className="flex items-center gap-2" data-id="element-142">
          <Orbit className="w-8 h-8 text-cyan-400 animate-[spin_10s_linear_infinite]" data-id="element-143" />
          <span className="font-display font-bold text-2xl tracking-widest text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.5)]" data-id="element-144">
            NEBULA
          </span>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-145">
          <div className="flex items-center gap-6" data-id="element-146">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-cyan-400 transition-colors" data-id="element-147">
                {link.name}
              </a>)}
          </div>
          <button className="relative group px-6 py-2 rounded-full bg-transparent border border-cyan-500/50 text-cyan-400 font-medium overflow-hidden transition-all hover:border-cyan-400 hover:shadow-[0_0_20px_rgba(6,182,212,0.4)]" data-id="element-148">
            <span className="relative z-10" data-id="element-149">הצטרפו למסע</span>
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-violet-500/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-150" />
          </button>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-151">
          {mobileMenuOpen ? <X data-id="element-152" /> : <Menu data-id="element-153" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="md:hidden absolute top-full left-0 right-0 bg-[#03040a]/95 backdrop-blur-xl border-b border-white/10 py-4 px-6 flex flex-col gap-4" data-id="element-154">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-gray-300 hover:text-cyan-400 py-2 border-b border-white/5" data-id="element-155">
              {link.name}
            </a>)}
          <button className="mt-4 w-full px-6 py-3 rounded-full bg-gradient-to-r from-cyan-600 to-violet-600 text-white font-medium shadow-[0_0_15px_rgba(6,182,212,0.3)]" data-id="element-156">
            הצטרפו למסע
          </button>
        </motion.div>}
    </nav>;
}